export default __webpack_public_path__ + "static/media/trim.00cd216d.mp4";